/**
 * Command types for the Mission Control ↔ CLI protocol.
 * Includes prompt response types and control commands like mode switching.
 */
export const COMMAND_TYPES = {
  ASK_USER_RESPONSE: 'ask_user_response',
  ELICITATION_RESPONSE: 'elicitation_response',
  PLAN_APPROVAL_RESPONSE: 'plan_approval_response',
  PERMISSION_RESPONSE: 'permission_response',
  MODE_SWITCH: 'mode_switch',
  ABORT: 'abort',
} as const
